import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Evenements() {
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-stone-50 font-sans overflow-x-hidden">
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(32px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes pulse-slow {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.08); opacity: 0.85; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes bounce-dot {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
          40% { transform: scale(1); opacity: 1; }
        }
        .anim-fade-up { animation: fadeInUp 0.8s ease forwards; }
        .anim-fade-down { animation: fadeInDown 0.6s ease forwards; }
        .anim-fade { animation: fadeIn 1s ease forwards; }
        .anim-float { animation: float 3s ease-in-out infinite; }
        .anim-pulse-slow { animation: pulse-slow 2.5s ease-in-out infinite; }
        .anim-spin-slow { animation: spin-slow 8s linear infinite; }
        .delay-100 { animation-delay: 0.1s; }
        .delay-200 { animation-delay: 0.2s; }
        .delay-300 { animation-delay: 0.3s; }
        .delay-400 { animation-delay: 0.4s; }
        .delay-500 { animation-delay: 0.5s; }
        .dot1 { animation: bounce-dot 1.4s ease-in-out infinite; animation-delay: 0s; }
        .dot2 { animation: bounce-dot 1.4s ease-in-out infinite; animation-delay: 0.2s; }
        .dot3 { animation: bounce-dot 1.4s ease-in-out infinite; animation-delay: 0.4s; }
      `}</style>

      {/* Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-gradient-to-b from-black/50 to-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-3">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/dfa72d9a3b42134ca8a29524dee02dd7.png"
              alt="KEIKI Logo"
              className="h-10 w-10 object-contain"
            />
            <span className={`hidden sm:block text-lg font-semibold transition-colors ${scrolled ? 'text-gray-900' : 'text-white drop-shadow-md'}`}>KEIKI</span>
          </Link>
          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href="tel:+68987735594"
              className="flex items-center gap-1.5 px-3 sm:px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-full transition-all text-sm font-medium whitespace-nowrap cursor-pointer shadow-md"
            >
              <i className="ri-phone-line"></i>
              <span className="hidden sm:inline">Réserver</span>
            </a>
            <Link
              to="/"
              className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full transition-all text-sm font-medium whitespace-nowrap cursor-pointer border ${scrolled ? 'bg-gray-100 hover:bg-gray-200 text-gray-700 border-gray-200' : 'bg-white/20 backdrop-blur-md border-white/40 hover:bg-white/30 text-white shadow-md'}`}
            >
              <i className="ri-home-line"></i>
              <span className="hidden sm:inline">Accueil</span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative h-72 sm:h-96 flex items-end justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/8e89c7bdfa462aa9185cd223715f9824.jpg"
            alt="Événements KEIKI Moorea"
            className="w-full h-full object-cover object-top"
            style={{ animation: 'fadeIn 1.2s ease forwards' }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20"></div>
        </div>
        <div className={`relative z-10 text-center pb-12 px-6 opacity-0 ${visible ? 'anim-fade-up' : ''}`}>
          <p className="text-emerald-300 text-sm font-semibold tracking-widest uppercase mb-2">KEIKI · Moorea</p>
          <h1 className="text-5xl sm:text-6xl font-serif text-white" style={{ textShadow: '0 2px 16px rgba(0,0,0,0.7)' }}>
            Événements
          </h1>
          <p className="text-white/80 mt-3 text-lg font-light" style={{ textShadow: '0 1px 8px rgba(0,0,0,0.6)' }}>
            Soirées, ateliers &amp; moments uniques à Moorea
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div
          className={`relative overflow-hidden bg-gradient-to-br from-emerald-700 to-teal-800 rounded-3xl p-10 sm:p-14 text-center text-white shadow-xl opacity-0 ${visible ? 'anim-fade-up delay-200' : ''}`}
        >
          {/* Decorative circles */}
          <div className="absolute -top-10 -left-10 w-40 h-40 rounded-full bg-white/5 anim-spin-slow"></div>
          <div className="absolute -bottom-8 -right-8 w-32 h-32 rounded-full bg-white/5 anim-spin-slow" style={{ animationDirection: 'reverse' }}></div>
          <div className="absolute top-6 right-16 w-6 h-6 rounded-full bg-emerald-300/30 anim-float"></div>
          <div className="absolute bottom-10 left-20 w-4 h-4 rounded-full bg-teal-200/30 anim-float delay-300"></div>

          {/* Icon animé */}
          <div className="relative w-20 h-20 flex items-center justify-center bg-white/15 rounded-full mx-auto mb-6 anim-pulse-slow">
            <i className="ri-calendar-event-line text-4xl text-white"></i>
          </div>

          {/* Badge "Bientôt" */}
          <div className="inline-flex items-center gap-2 bg-white/20 border border-white/30 rounded-full px-4 py-1.5 mb-5">
            <span className="flex gap-1 items-center">
              <span className="w-2 h-2 rounded-full bg-emerald-300 dot1 inline-block"></span>
              <span className="w-2 h-2 rounded-full bg-emerald-300 dot2 inline-block"></span>
              <span className="w-2 h-2 rounded-full bg-emerald-300 dot3 inline-block"></span>
            </span>
            <span className="text-sm font-semibold tracking-wide text-emerald-200 uppercase">Prochainement</span>
          </div>

          <h3 className="text-3xl sm:text-4xl font-serif mb-3">Événements à venir</h3>
          <p className="text-white/80 text-lg mb-2 max-w-xl mx-auto">
            Restez connectés — de belles surprises arrivent bientôt !
          </p>
          <p className="text-white/60 text-sm mb-8 max-w-lg mx-auto">
            Pour être informé en avant-première ou réserver votre place, contactez-nous directement.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+68987735594"
              className="flex items-center gap-2 bg-white text-emerald-700 hover:bg-emerald-50 px-7 py-3.5 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer shadow-md hover:scale-105 active:scale-95"
              style={{ transition: 'all 0.2s ease' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line"></i>
              </div>
              +689 87 73 55 94
            </a>
            <a
              href="mailto:ke.iki@hotmail.com"
              className="flex items-center gap-2 bg-white/20 hover:bg-white/30 border border-white/40 text-white px-7 py-3.5 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95"
              style={{ transition: 'all 0.2s ease' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line"></i>
              </div>
              ke.iki@hotmail.com
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-stone-800 via-gray-800 to-stone-900 text-white py-10">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/60">
          <p>© {new Date().getFullYear()} KEIKI — Moorea | Terrasse • Parking gratuit • Accessible PMR | LGBTQ+ friendly 🌈</p>
          <div className="flex items-center gap-6">
            <Link to="/" className="hover:text-white transition-colors cursor-pointer">Accueil</Link>
            <a href="tel:+68987735594" className="hover:text-white transition-colors cursor-pointer">Réserver</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
